export const getRosData = async () => {
  const url = '/api/home/get_column'
  const res = await fetch(url)
  const json = await res.json()
  return json
}

export const addRosData = async (params) => {
  const url = '/api/home/insert'
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  })
  const json = await res.json()
  return json
}

export const submitPicture = async (params) => {
  const url = '/api/home/upload'
  const res = await fetch(url, {
    method: 'POST',
    body: params,
    headers: {}
  })
  const json = await res.json()
  return json
}

// --- Config Assistant (device flasher) helpers ---

const fetchJsonChecked = async (url, opts) => {
  const res = await fetch(url, opts)
  let payload
  try {
    payload = await res.json()
  } catch (e) {
    payload = null
  }

  if (!res.ok) {
    const msg = (payload && (payload.message || payload.msg)) ? (payload.message || payload.msg) : `HTTP ${res.status}`
    const err = new Error(msg)
    err.status = res.status
    err.payload = payload
    throw err
  }

  return payload
}

// NOTE: These endpoints are placeholders. Update paths/params to match your backend.
export const getWmsDeviceHardware = async (deviceId) => {
  const url = `/api/wms/device/hardware?deviceId=${encodeURIComponent(deviceId)}`
  return await fetchJsonChecked(url)
}

// Expected to return the latest firmware for a given hardware version.
// Recommended response shape:
// { version, hardwareVersion, name, size, sha256, downloadUrl, manifestUrl, releaseNotes }
export const getLatestFirmware = async (deviceType, hardwareVersion, firmwareType = '') => {
  const q = [
    `deviceType=${encodeURIComponent(deviceType)}`,
    `hardwareVersion=${encodeURIComponent(hardwareVersion)}`
  ]
  if (firmwareType) q.push(`firmwareType=${encodeURIComponent(firmwareType)}`)
  const url = `/api/firmware/latest?${q.join('&')}`
  return await fetchJsonChecked(url)
}

export const getFirmwareListByDeviceId = async (deviceId) => {
  const url = `/api/firmware/list?deviceId=${encodeURIComponent(deviceId)}`
  return await fetchJsonChecked(url)
}

export const getNavLinks = async (query = '', catelog = '') => {
  const q = []
  if (query) q.push(`query=${encodeURIComponent(query)}`)
  if (catelog) q.push(`catelog=${encodeURIComponent(catelog)}`)
  const url = `/api/nav/links${q.length ? `?${q.join('&')}` : ''}`
  return await fetchJsonChecked(url)
}

export const getProducts = async () => {
  let controller = null
  let timeout = null
  if (typeof AbortController !== 'undefined') {
    controller = new AbortController()
    timeout = setTimeout(() => controller.abort(), 8000)
  }
  try {
    return await fetchJsonChecked('/api/products', controller ? { signal: controller.signal } : undefined)
  } finally {
    if (timeout) clearTimeout(timeout)
  }
}

export const getTutorialVideos = async () => {
  let controller = null
  let timeout = null
  if (typeof AbortController !== 'undefined') {
    controller = new AbortController()
    timeout = setTimeout(() => controller.abort(), 8000)
  }
  try {
    return await fetchJsonChecked('/api/tutorial-videos', controller ? { signal: controller.signal } : undefined)
  } finally {
    if (timeout) clearTimeout(timeout)
  }
}
